import { useParams } from "react-router-dom";
import { Percent, Check, CalendarClock, Droplets } from "lucide-react";
import { PARTNER_BUILDINGS } from "@/data/site";
import { Seo } from "@/components/Seo";
import { LeadForm } from "@/components/LeadForm";
import NotFound from "@/pages/NotFound";

const BENEFITS = [
  { icon: Percent, text: "10% off repairs" },
  { icon: Check, text: "Annual Maintenance Plan for $219/year instead of $249" },
  { icon: CalendarClock, text: "Priority scheduling" },
  { icon: Droplets, text: "Drain line cleaning at every tune-up" },
];

export default function PartnerBuilding() {
  const { buildingSlug } = useParams();
  const building = PARTNER_BUILDINGS[buildingSlug];

  if (!building) return <NotFound />;

  return (
    <div data-testid={`partner-page-${buildingSlug}`}>
      <Seo title={`${building.name} Resident AC Benefits | Central Air Depot`} description={`Exclusive AC repair and maintenance benefits for ${building.name} residents through the Central Air Depot Association Partner Program.`} noindex />
      <section className="bg-brand-ink text-white">
        <div className="max-w-4xl mx-auto px-4 py-16 sm:py-24 text-center">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-3">Association Partner Program</p>
          <h1 data-testid="partner-welcome-headline" className="text-4xl sm:text-5xl tracking-tighter leading-none font-black">
            Welcome, {building.name} residents
          </h1>
          <p className="text-base sm:text-lg text-zinc-300 mt-5 max-w-xl mx-auto">
            Your building is a Central Air Depot partner — these benefits are yours whenever you need AC help.
          </p>
        </div>
      </section>
      <section className="bg-brand-subtle">
        <div className="max-w-4xl mx-auto px-4 py-16">
          <div className="bg-white border border-zinc-200 p-8 rounded-sm">
            <h2 className="font-heading font-black text-2xl text-brand-ink">Your resident benefits</h2>
            <ul className="mt-5 space-y-4">
              {BENEFITS.map((b) => (
                <li key={b.text} className="flex items-start gap-3 text-sm text-zinc-700">
                  <b.icon className="w-5 h-5 text-brand shrink-0 mt-0.5" /> {b.text}
                </li>
              ))}
            </ul>
            <a href={building.planUrl} target="_blank" rel="noopener noreferrer" data-testid="partner-join-plan-btn"
              className="mt-8 block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 rounded-sm transition-colors duration-200">
              Join the Plan — $219/year
            </a>
          </div>
          <div className="mt-8">
            <LeadForm building={building.name} heading={`Request Service at ${building.name}`} subtext="Tell us what's going on — partner-building residents get priority scheduling." />
          </div>
        </div>
      </section>
    </div>
  );
}
